import $ from 'jquery';
import jump from 'jump.js';
import matchHeight from 'jquery-match-height';

export default function pageTweaks() {

    // SMOOTH SCROLLING: function
    function smoothScrolling() {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('.magnific-inline').click(function(event) {

            if($(this).hasClass('page-rots-thumb')) {
                revitalizationLogic($(this));
            }

            $('html').css('overflow-y', 'auto');
            $('#trigger-menu').removeClass('is-triggered');
            $('#site-navigation').fadeOut(200);

                if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top - 78
                        }, 1000, function() {
                        });
                    }
                }

        });
    }
    smoothScrolling();

    // SMOOTH SCROLLING on page load
    let hash = document.location.hash;
    if (hash) {
        jump(hash, {
            duration: 1000,
            offset: -78
        });
    }

    // PAGE: Revitalization of three stations extend description
    $('.page-rots-extend-more').on('click', function() {
        if($(this).hasClass('is-extended')) {
            $(this).removeClass('is-extended');
            $(this).find('.page-rots-extend-open').show();
            $(this).find('.page-rots-extend-close').hide();
            $(this).next('.page-rots-extend-hidden').slideUp(400);
        } else {
            $(this).addClass('is-extended');
            $(this).find('.page-rots-extend-open').hide();
            $(this).find('.page-rots-extend-close').show();
            $(this).next('.page-rots-extend-hidden').slideDown(400);
        }
    });

    function revitalizationLogic(element) {
        $('.page-rots-extend-more').removeClass('is-extended');
        $('.page-rots-extend-open').show();
        $('.page-rots-extend-close').hide();
        $('.page-rots-extend-hidden').hide();

        var stationTarget = element.attr('href');

        $(stationTarget).find('.page-rots-extend-more').addClass('is-extended');
        $(stationTarget).find('.page-rots-extend-open').hide();
        $(stationTarget).find('.page-rots-extend-close').show();
        $(stationTarget).find('.page-rots-extend-hidden').show();
    }

    // PAGE: Questions and answers
    $('.page-qanda-question').on('click', function() {
        if ( $(this).hasClass('clicked') ) {
            $('.page-qanda-question').removeClass('clicked');
            $('.page-qanda-answer').slideUp(200);
            $(this).removeClass('clicked');
        } else {
            $('.page-qanda-question').removeClass('clicked');
            $('.page-qanda-answer').slideUp(200);
            $(this).addClass('clicked').next('.page-qanda-answer').slideDown(200);
        }
    });

    // Match height
    $('.news-content').matchHeight();

    // Always open PDF links in new window
    $('a[href$=".pdf"]').prop('target', '_blank');
}


// WEBPACK FOOTER //
// ./components/page-tweaks.js